import { Outlet } from 'react-router-dom'
import { Sidebar } from '../components/Sidebar'
import { useNotificationInbox } from '../hooks/useNotifications'
import '../styles/vendor-shell.scss'

export function VendorShell() {
  useNotificationInbox()

  return (
    <div className="vendor-shell">
      <Sidebar />
      <div className="vendor-shell__main">
        <Outlet />
      </div>
    </div>
  )
}
